import { SortArrow } from '@shared/assets/icons/components';
import { type FC } from 'react';
import classNames from 'classnames';

import { THeadCellText, type THeadCellTextProps } from '../thead-cell-text';
import styles from './thead-cell-sortable.module.scss';
import { Flex } from 'antd';

export type THeadCellSortableProps = THeadCellTextProps & {
  isSorted?: boolean;
  isDesc?: boolean;
  onSort?: () => void;
};

export const THeadCellSortable: FC<THeadCellSortableProps> = ({
  children,
  isSorted,
  isDesc,
  width,
  onSort,
  ...props
}) => {
  const sortClassNames = classNames(styles.sort, {
    [styles.sort_sorted]: isSorted,
    [styles.sort_asc]: isSorted && !isDesc,
  });

  return (
    <THeadCellText className={styles.root} onClick={onSort} {...props} width={width}>
      <Flex
        align="center"
        style={{
          columnGap: '4px',
          width,
        }}
      >
        {children}
        <SortArrow width="16px" height="16px" className={sortClassNames} />
      </Flex>
    </THeadCellText>
  );
};
